import { Component, ViewChild, ElementRef, AfterViewInit, Input } from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import {
    BusinessComponentsProvider,
    AuthClientConfig,
} from "@dfds-platform/business-components";
import OktaLogin from "./okta.login";
import { OktaService } from "./okta.service";
import OktaPopup from './okta.popup';
import { Observable } from 'rxjs';
import OktaTracking from "./okta.tracking";
import { TrackingService } from "../shared/tracking/tracking.service";

@Component({
    selector: "sbw-okta",
    template: "<div #react></div>",
})
export class OktaProviderComponent implements AfterViewInit {
    [x: string]: any;
    constructor(
        public oktaService: OktaService,
        public trackingService: TrackingService
    ) { }

    @Input() content: Observable<any>

    @ViewChild("react", { static: true }) react: ElementRef;

    resources: OktaResources = null

    ngAfterViewInit() {
        this.content.subscribe(c => {
            this.resources = c

            this.render()
        })
    }

    render() {
        const OktaProvider = ({ }) => {
            const oktaConfig: AuthClientConfig = {
                applicationEnvironment: window["okta_environment"],
                clientId: window["okta_clientId"],
                issuer: window["okta_issuer"],
                scopes: ["openid", "email", "profile", "Customer-Retention.LoyaltycardApi.Readcurrentuser", "Customer-Retention.LoyaltycardApi.Writecurrentuser"],
                businessArea: "Passenger",
                redirectUri: window.location.origin,
                newsletterSource: window["okta_newsletter_sourceId"]
            };

            return (
                <BusinessComponentsProvider oktaConfig={oktaConfig}>
                    <OktaTracking trackingService={this.trackingService} />
                    <OktaLogin
                        onSubmitted={this.oktaService.onOktaSubmitted}
                        onLoggingOut={this.oktaService.onOktaLogout}
                        onLoggedOut={this.oktaService.onOktaLoggedOut}
                        onLoggedIn={this.oktaService.onOktaLoggedIn}
                        onClose={this.oktaService.onOktaClose}
                        onReady={this.oktaService.onOktaReady}
                    />
                    {this.resources &&
                        <OktaPopup
                            cmsData={this.resources}
                            onExpiry={this.oktaService.onOktaAboutToExpire}
                            onClearSession={this.oktaService.onOktaClearSession}
                            onSessionExtended={this.oktaService.onOktaSessionExtended} />
                    }
                </BusinessComponentsProvider>
            );
        };

        ReactDOM.render(<OktaProvider />, this.react.nativeElement);
    }
}

export interface OktaResources {
    oktaSessionExpiredHeader: string
    oktaSessionAboutToExpireHeader: string
    oktaSessionExpiredDescription: string
    oktaSessionAboutToExpireDescription: string
    oktaResumeSessionButton: string
    oktaStartOverButton: string
}
